import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axios'
import VueRouter from 'vue-router'
import ui from './utils/ui'
import NrIcon from './components/common/Icon.vue'

const appTheme = localStorage.getItem('theme') || 'system'
if (appTheme === 'system') document.documentElement.removeAttribute('data-theme')
else document.documentElement.setAttribute('data-theme', appTheme)

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ui) // 自研 $message/$confirm
Vue.component('NrIcon', NrIcon)
Vue.component('nricon', NrIcon) // 模板中使用全小写 <nricon>，需注册同名标签


store.dispatch('initUserState').finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
